// import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'

createRoot(document.getElementById('root')!).render(
  // 开发环境下 StrictMode 会导致组件渲染两次
  // <React.StrictMode> 
    <App />
  // </React.StrictMode>
)
